/**
 * Sub menu display
 */
const dropdownTriggers = document.querySelectorAll(
  '.menu > .menu-item-has-children'
);

function handleEnter() {
  this.classList.add('trigger-enter');

  setTimeout(() => {
    this.classList.add('trigger-enter-active');
  }, 300);
}

function handleLeave() {
  setTimeout(() => {
    this.classList.remove('trigger-enter', 'trigger-enter-active');
  }, 300);
}

dropdownTriggers.forEach((trigger) => {
  trigger.addEventListener('mouseenter', handleEnter);
});

dropdownTriggers.forEach((trigger) => {
  trigger.addEventListener('mouseleave', handleLeave);
});
